<template>
  <div class="comp-zj-section-title bg-white" :style="{'font-size':size + 'px'}">
    <span>
      <span class="title" v-if="border" :style="{'border-left': '3px solid ' + color}">{{title}}</span>
    <span class="title" v-else>{{title}}</span>
    <slot name="label">
      <small class="f14 text-color-3" v-if="label">{{label}}</small>
    </slot>
    </span>
    <slot name="btn"></slot>
  </div>
</template>

<script>
  export default {
    name: 'comp-zj-section-title',
    props: {
      title: {
        type: String,
        default: 'section-标题'
      },
      border: {
        type: Boolean,
        default: true
      },
      size: {
        type: Number,
        required: false,
        default: 22
      },
      color: {
        type: String,
        default: '#00AAFF'
      },
      vip: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        required: false
      }
    }
  }
</script>

<style lang="less">
  @import '../../styles/_mixins-wln';

  .comp-zj-section-title {
    padding: 1em 10px 1em 0;

    .title {
      padding-left: 17px;
      box-sizing: border-box;
      font-weight: bold;
    }

    .vip {
      img {
        width: 12px;
      }
    }
  }

</style>
